import "core-js/modules/es.array.sort.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("template", {
    slot: "header"
  }, [_c("el-breadcrumb", {
    attrs: {
      separator: "/"
    }
  }, [_c("el-breadcrumb-item", {
    attrs: {
      to: {
        path: "/article/activity"
      }
    }
  }, [_vm._v("体验管理")]), _c("el-breadcrumb-item", [_vm._v("编辑体验")])], 1)], 1), _c("el-form", {
    staticClass: "wlc-form-page",
    attrs: {
      model: _vm.form,
      "label-position": "left",
      "label-width": "80px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "语言"
    }
  }, [_c("el-radio-group", {
    model: {
      value: _vm.lang,
      callback: function callback($$v) {
        _vm.lang = $$v;
      },
      expression: "lang"
    }
  }, [_c("el-radio-button", {
    attrs: {
      label: "zh"
    }
  }, [_vm._v("中文")]), _c("el-radio-button", {
    attrs: {
      label: "en"
    }
  }, [_vm._v("英文")]), _c("el-radio-button", {
    attrs: {
      label: "tw"
    }
  }, [_vm._v("繁体")])], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "标题"
    }
  }, [_vm.lang == "zh" ? _c("el-input", {
    model: {
      value: _vm.form.ch.title,
      callback: function callback($$v) {
        _vm.$set(_vm.form.ch, "title", $$v);
      },
      expression: "form.ch.title"
    }
  }) : _vm._e(), _vm.lang == "en" ? _c("el-input", {
    model: {
      value: _vm.form.en.title,
      callback: function callback($$v) {
        _vm.$set(_vm.form.en, "title", $$v);
      },
      expression: "form.en.title"
    }
  }) : _vm._e(), _vm.lang == "tw" ? _c("el-input", {
    model: {
      value: _vm.form.tw.title,
      callback: function callback($$v) {
        _vm.$set(_vm.form.tw, "title", $$v);
      },
      expression: "form.tw.title"
    }
  }) : _vm._e()], 1), _c("el-form-item", {
    attrs: {
      label: "简述"
    }
  }, [_vm.lang == "zh" ? _c("el-input", {
    model: {
      value: _vm.form.ch.intro,
      callback: function callback($$v) {
        _vm.$set(_vm.form.ch, "intro", $$v);
      },
      expression: "form.ch.intro"
    }
  }) : _vm._e(), _vm.lang == "en" ? _c("el-input", {
    model: {
      value: _vm.form.en.intro,
      callback: function callback($$v) {
        _vm.$set(_vm.form.en, "intro", $$v);
      },
      expression: "form.en.intro"
    }
  }) : _vm._e(), _vm.lang == "tw" ? _c("el-input", {
    model: {
      value: _vm.form.tw.intro,
      callback: function callback($$v) {
        _vm.$set(_vm.form.tw, "intro", $$v);
      },
      expression: "form.tw.intro"
    }
  }) : _vm._e()], 1), _c("el-form-item", {
    staticStyle: {
      width: "252px"
    },
    attrs: {
      label: "排序"
    }
  }, [_c("el-input", {
    attrs: {
      type: "number",
      min: 0
    },
    model: {
      value: _vm.form.sort,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "sort", $$v);
      },
      expression: "form.sort"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "图片"
    }
  }, [_c("wlc-upload-image", {
    attrs: {
      url: _vm.form.ch.url,
      multimediaType: "homeStoryPic"
    },
    on: {
      "update:url": function updateUrl($event) {
        return _vm.$set(_vm.form.ch, "url", $event);
      }
    }
  }), _c("wlc-image-info", {
    attrs: {
      url: _vm.form.ch.url
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "票图片"
    }
  }, [_c("wlc-upload-image", {
    attrs: {
      url: _vm.form.templateImg,
      multimediaType: "homeStoryPic"
    },
    on: {
      "update:url": function updateUrl($event) {
        return _vm.$set(_vm.form, "templateImg", $event);
      }
    }
  }), _c("wlc-image-info", {
    attrs: {
      url: _vm.form.templateImg
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "票名称"
    }
  }, [_vm.lang == "zh" ? _c("el-input", {
    model: {
      value: _vm.form.ticketName.ch,
      callback: function callback($$v) {
        _vm.$set(_vm.form.ticketName, "ch", $$v);
      },
      expression: "form.ticketName.ch"
    }
  }) : _vm._e(), _vm.lang == "en" ? _c("el-input", {
    model: {
      value: _vm.form.ticketName.en,
      callback: function callback($$v) {
        _vm.$set(_vm.form.ticketName, "en", $$v);
      },
      expression: "form.ticketName.en"
    }
  }) : _vm._e(), _vm.lang == "tw" ? _c("el-input", {
    model: {
      value: _vm.form.ticketName.tw,
      callback: function callback($$v) {
        _vm.$set(_vm.form.ticketName, "tw", $$v);
      },
      expression: "form.ticketName.tw"
    }
  }) : _vm._e()], 1), _c("el-form-item", {
    staticStyle: {
      width: "252px"
    },
    attrs: {
      label: "价格"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.price,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "price", $$v);
      },
      expression: "form.price"
    }
  })], 1), _c("el-form-item", {
    staticStyle: {
      width: "252px"
    },
    attrs: {
      label: "尊享价格"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.discountPrice,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "discountPrice", $$v);
      },
      expression: "form.discountPrice"
    }
  })], 1), _c("el-form-item", {
    staticStyle: {
      width: "252px"
    },
    attrs: {
      label: "活动人数"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.number,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "number", $$v);
      },
      expression: "form.number"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "活动地址"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.address,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "address", $$v);
      },
      expression: "form.address"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "内容"
    }
  }, [!_vm.loading ? _c("div", {
    staticClass: "editor-container"
  }, [_c("wlc-rich-text", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.lang === "zh",
      expression: "lang === 'zh'"
    }],
    attrs: {
      content: _vm.form.ch.content,
      id: "zh_".concat(_vm.$route.query.id)
    },
    on: {
      "update:content": function updateContent($event) {
        return _vm.$set(_vm.form.ch, "content", $event);
      }
    }
  }), _c("wlc-rich-text", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.lang === "en",
      expression: "lang === 'en'"
    }],
    attrs: {
      content: _vm.form.en.content,
      id: "en_".concat(_vm.$route.query.id)
    },
    on: {
      "update:content": function updateContent($event) {
        return _vm.$set(_vm.form.en, "content", $event);
      }
    }
  }), _c("wlc-rich-text", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.lang === "tw",
      expression: "lang === 'tw'"
    }],
    attrs: {
      content: _vm.form.tw.content,
      id: "tw_".concat(_vm.$route.query.id)
    },
    on: {
      "update:content": function updateContent($event) {
        return _vm.$set(_vm.form.tw, "content", $event);
      }
    }
  })], 1) : _vm._e()]), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("提交")])], 1)], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };